import Img from "../../assets/images/firstArticle.jpg";
import Mashlow from "../../assets/images/maslowneeds.png";
import "../../styles/article-page.css";
import "../../styles/article-data.css";

export const articlesData = {
    "understanding-motivation-goal-management": {
        title: "Understanding Motivation and Goal Management",
        date: "April 8, 2026",
        image: Img,
        content: (
            <>
                <div className="content">
                    <p>
                        Everyone has goals. Some are small, like improving daily habits, while others are ambitious, like building a business or transforming your life. But no matter the size of the goal, one truth remains: nothing meaningful happens overnight.
                    </p>
                    <p>
                        Success is built step by step—and behind every step is motivation.
                    </p>
                    <p>
                        <strong>What is motivation, exactly? </strong>
                        Motivation is the interaction between your goals, your emotional state, your confidence in your abilities, and the opportunities your environment provides. In simple terms, motivation is the force that pushes you to act.
                    </p>
                    <p>
                        <strong>What does it mean to be motivated? </strong>
                        To be motivated means to pursue something you believe is valuable, necessary, or meaningful. We are constantly driven by the desire to improve our situation, satisfy a need, or achieve something important to us.
                    </p>
                        
                    <p><strong>What are we truly seeking when we feel motivated? </strong>
                        According to Abraham Maslow’s Hierarchy of Needs, human motivation is deeply connected to our needs. These range from basic survival needs like food and safety, to higher-level needs such as belonging, confidence, achievement, and self-actualization.
                    </p>
                    <p>
                        This helps explain why motivation looks different for everyone: people pursue different goals depending on what they currently need most in life.
                    </p>
                    <img src={Mashlow} alt="Maslow Pyramid" className="mashlow-pyramid" />
                    <p>
                        Understanding human needs explains <em>why</em> we are motivated—but knowing how to use that motivation is what turns desire into results.
                    </p>
                    <p>
                        Here are the <strong>9 essential principles of effective goal setting</strong> that can help you build stronger motivation and achieve goals more consistently:
                    </p>
                    <h1>The 9 Principles of Effective Goal Setting</h1>
                    <p>
                        <strong>1. Give Your Goal a Purpose</strong>:
                        Every goal needs a strong reason behind it. If your “why” is weak, your motivation will disappear when things get difficult.
                    </p>
                    <p>
                        <strong>2. Make It Specific</strong>:
                        Vague goals create vague results. Define exactly what you want, by when, and how success will be measured.
                    </p>
                    <p>
                        <strong>3. Keep It Realistic</strong>:
                        Your goal should challenge you—but still feel achievable. If it feels impossible, motivation drops quickly.
                    </p>
                    <p>
                        <strong>4. Enjoy the Process</strong>:
                        Goals are easier to pursue when the journey is meaningful or enjoyable. Discipline matters, but enjoyment increases consistency.
                    </p>
                    <p>
                        <strong>5. Use Your Potential</strong>:
                        Ask yourself what resources, habits, and strengths can help you perform at your best.
                    </p>
                    <p>
                        <strong>6. Find Your Pace</strong>:
                        Some people move fast. Others move steadily. The key is choosing a rhythm you can maintain long term.
                    </p>
                    <p>
                        <strong>7. Break It Into Steps</strong>:
                        Big goals feel overwhelming until they are broken down into smaller, manageable milestones.
                    </p>
                    <p>
                        <strong>8. Build a Plan</strong>:
                        Motivation without planning leads nowhere. Schedule your actions and create a roadmap.
                    </p>
                    <p>
                        <strong>9. Focus on Priorities</strong>:
                        Success comes from what you repeatedly prioritize each day—not from occasional bursts of motivation.
                    </p>
                    <p>
                        At the end of the day, motivation is not something you wait for. It is something you build through clarity, structure, and purposeful action.
                    </p>
                    <p>
                        When you understand your needs, define meaningful goals, and follow a clear plan, motivation becomes far more sustainable—and success becomes far more likely.
                    </p>
                </div>
            </>
        ),
    },
    /*
    "ai-a-tool-that-turn-back": {
        title: "Artifical intelligence a tool that turn back time?",
        date: "April 9, 2026",
        image: Img,
        content: <p>Contenu de mon second article...</p>,
    },
    "ai-a-tool-that-turn-back-time": {
        title: "Artifical intelligence a tool that turn back time?",
        date: "April 9, 2026",
        image: Img,
        content: <p>Contenu de mon second article...</p>,
    },
    */
};